module.exports = __webpack_public_path__ + "static/media/logo_himaja.1ad3dbe9.png";